import React,{useState} from 'react'
import CmsNavbar from '../../CmsComponents/CmsNavbar';
import CmsSidebar from '../../CmsComponents/CmsSidebar';

import RoomAdmin from '../../CmsComponents/RoomAdmin';

function RoomAdminPage() {
    const [isOpen,setIsOpen]= useState(false);

    function HandleClicked() {
        setIsOpen(!isOpen);
    }

    return (
        <div>
            <CmsNavbar action={HandleClicked} />
            <CmsSidebar isOpen={isOpen} />
            <RoomAdmin isOpen={isOpen} />
        </div>
    )
}

export default RoomAdminPage;